import React, { Component } from 'react';
import styled from '@emotion/styled';
import { SPACING } from 'Style/spacing';

import connector from 'Utils/connector';
import connectAmp, {
  ConnectAmpProps,
} from 'Webapp/shared/app/connectors/connectAmp';
import connectResponsive, {
  ConnectResponsiveProps,
} from 'Webapp/shared/app/connectors/connectResponsive';
import connectFeatureFlags, {
  ConnectFeatureFlagsProps,
} from 'Webapp/shared/app/connectors/connectFeatureFlags';
import connectAdTargeting, {
  ConnectAdTargetingProps,
} from 'Webapp/shared/app/connectors/connectAdTargeting';

import AdSlot from './ad-slot';
import {
  AD_UNIT_PATHS,
  MEDIUM_RECTANGLE_SIZES,
  isArticleRailAdEnabled,
} from './ads-config';
import { setPageTargeting } from './gpt';

const StyledRailAdWrapper = styled.div({
  marginBottom: SPACING.XLARGE,
});

type ArticleRailAdProps = ConnectAmpProps &
  ConnectResponsiveProps &
  ConnectFeatureFlagsProps &
  ConnectAdTargetingProps;

/**
 * 300x250 in the right rail of the on-site article page, above the related
 * "More Stories" content (see views/article.js). Lazily loaded and only
 * rendered on viewports wide enough that the rail exists (desktop).
 */
class ArticleRailAd extends Component<ArticleRailAdProps> {
  componentDidMount() {
    this.applyPageTargeting();
  }

  componentDidUpdate(prevProps: ArticleRailAdProps) {
    if (
      prevProps.adPageType !== this.props.adPageType ||
      prevProps.adTopicSlug !== this.props.adTopicSlug
    ) {
      this.applyPageTargeting();
    }
  }

  shouldRender = () => {
    const { isAmp, isDesktop, featureFlags } = this.props;
    return !isAmp && isDesktop && isArticleRailAdEnabled(featureFlags);
  };

  applyPageTargeting = () => {
    if (!this.shouldRender()) {
      return;
    }
    setPageTargeting({
      page_type: this.props.adPageType,
      topic_slug: this.props.adTopicSlug,
    });
  };

  render() {
    if (!this.shouldRender()) {
      return null;
    }
    const { adPageType, adTopicSlug } = this.props;
    const targeting: Record<string, string> = {};
    if (adPageType) {
      targeting.page_type = adPageType;
    }
    if (adTopicSlug) {
      targeting.topic_slug = adTopicSlug;
    }
    return (
      <StyledRailAdWrapper>
        <AdSlot
          name="article-rail"
          placementFlag="WEB_ADS_ARTICLE_RAIL"
          adUnitPath={AD_UNIT_PATHS.articleRail}
          sizes={MEDIUM_RECTANGLE_SIZES}
          lazy
          targeting={targeting}
        />
      </StyledRailAdWrapper>
    );
  }
}

export default connector<ArticleRailAdProps>(
  connectAmp,
  connectResponsive,
  connectFeatureFlags,
  connectAdTargeting,
)(ArticleRailAd);
